import { getStoreValue, setStoreValue } from '~/shared/lib/storage';
import { type Tokens } from '~/shared/types/auth';

export const getTokens = async (): Promise<Tokens> => {
    const tokens = await getStoreValue<Tokens>('tokens');

    if (!tokens) {
        return {
            accessToken: null,
        };
    }

    return tokens;
};

export const setTokens = async (tokens: Tokens): Promise<void> => {
    await setStoreValue('tokens', tokens);
};
